import { render, staticRenderFns } from "./InvoicePaymentData.vue?vue&type=template&id=6fbf50a9&scoped=true"
import script from "./InvoicePaymentData.vue?vue&type=script&lang=ts&setup=true"
export * from "./InvoicePaymentData.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./InvoicePaymentData.vue?vue&type=style&index=0&id=6fbf50a9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbf50a9",
  null
  
)

export default component.exports